import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// INTERFACES/INTERFACES  -------------------------------------------------
import { environment, JSON_HEADER } from '../../../environments/environment';

/**
 * Obtiene información haciendo consultas al API de Asambleas
 *
 * @export
 * @class RegistrationService
 */
@Injectable()
export class RegistrationService {

    constructor(public http: HttpClient) { }

    public getDistricts() {
        const headers = JSON_HEADER
        return this.http.get(environment.apiEndPoint + '/distritos', {
            headers
        });
    }

    public getDistrictDataById(id: number) {
        const headers = JSON_HEADER
        return this.http.get(environment.apiEndPoint + '/distritos/' + id, {
            headers
        });
    }

    public getSectionalDataById(id: number) {
        return this.http.get(environment.apiEndPoint + '/seccionales/' + id);
    }

    public userSignUp(data: UserSingUpRq) {
        const headers = JSON_HEADER

        return this.http.post(environment.apiEndPoint + '/usuarios/signup', data, {
            headers
        });
    }

}

export interface DistrictDataResponse {
    id: number,
    name: string,
    description: string,
    created_at: string,
    updated_at: string,
    sectionals: [
        {
            id: 1,
            name: string,
            description: string,
            created_at: string,
            updated_at: string,
            cities: [
                {
                    id: number,
                    name: string,
                    code: string,
                    created_at: string,
                    updated_at: string,
                    churches: [
                        {
                            id: number,
                            name: string,
                            address: string,
                            phone: number,
                            email: string,
                            latitude: string,
                            length: string,
                            created_at: string,
                            updated_at: string
                        }
                    ]
                }
            ]
        }
    ]
}

export interface UserSingUpRq {
    name: string
    surname: string
    second_name: string
    second_surname: string
    gender: string
    document_type: string
    document_number: string
    birthdate: string
    birthplace: string
    civil_status: string
    residence_address: string
    residence_city: string
    email: string
    is_academic: boolean
    provider: string
    password: string
    church_id: number
}



// WEBPACK FOOTER //
// ./src/app/services/registration/registration.service.ts